import CustomerService from '../../services/CustomerService';
import toast from 'react-hot-toast';

// Action Types
export const CUSTOMERS_LOADING = 'CUSTOMERS_LOADING';
export const CUSTOMERS_SUCCESS = 'CUSTOMERS_SUCCESS';
export const CUSTOMERS_FAIL = 'CUSTOMERS_FAIL';
export const CUSTOMER_GET_SUCCESS = 'CUSTOMER_GET_SUCCESS';
export const CUSTOMER_CREATE_SUCCESS = 'CUSTOMER_CREATE_SUCCESS';
export const CUSTOMER_UPDATE_SUCCESS = 'CUSTOMER_UPDATE_SUCCESS';
export const CUSTOMER_DELETE_SUCCESS = 'CUSTOMER_DELETE_SUCCESS';
export const CUSTOMERS_CLEAR_ERRORS = 'CUSTOMERS_CLEAR_ERRORS';
export const CUSTOMERS_CLEAR_CURRENT = 'CUSTOMERS_CLEAR_CURRENT';
export const CUSTOMERS_SET_PAGINATION = 'CUSTOMERS_SET_PAGINATION';

// Action Creators
export const setLoading = () => ({
    type: CUSTOMERS_LOADING
});

export const clearErrors = () => ({
    type: CUSTOMERS_CLEAR_ERRORS
});

export const clearCurrentCustomer = () => ({
    type: CUSTOMERS_CLEAR_CURRENT
});

// Get all customers with pagination and filters
export const getCustomersAction = (params = {}) => {
    return async (dispatch) => {
        try {
            dispatch(setLoading());
            
            const response = await CustomerService.listCustomers(params);
            
            if (response.success) {
                dispatch({
                    type: CUSTOMERS_SUCCESS,
                    payload: response.data
                });
                
                if (response.pagination) {
                    dispatch({
                        type: CUSTOMERS_SET_PAGINATION,
                        payload: response.pagination
                    });
                }
            } else {
                dispatch({
                    type: CUSTOMERS_FAIL,
                    payload: response.message || 'Failed to fetch customers'
                });
            }
            
            return response;
        } catch (error) {
            const errorMessage = error.message || 'An error occurred while fetching customers';
            dispatch({
                type: CUSTOMERS_FAIL,
                payload: errorMessage
            });
            throw error;
        }
    };
};

// Get single customer
export const getCustomerByIdAction = (customerId) => {
    return async (dispatch) => {
        try {
            dispatch(setLoading());
            
            const response = await CustomerService.getCustomer(customerId);
            
            if (response.success) {
                dispatch({
                    type: CUSTOMER_GET_SUCCESS,
                    payload: response.data
                });
            } else {
                dispatch({
                    type: CUSTOMERS_FAIL,
                    payload: response.message || 'Failed to fetch customer'
                });
            }
            
            return response;
        } catch (error) {
            const errorMessage = error.message || 'An error occurred while fetching customer';
            dispatch({
                type: CUSTOMERS_FAIL,
                payload: errorMessage
            });
            throw error;
        }
    };
};

// Create customer
export const createCustomerAction = (customerData, navigate) => {
    return async (dispatch) => {
        try {
            dispatch(setLoading());
            
            const response = await CustomerService.createCustomer(customerData);
            
            if (response.success) {
                dispatch({
                    type: CUSTOMER_CREATE_SUCCESS,
                    payload: response.data
                });
                
                toast.success(response.message || 'Customer created successfully');
                
                if (navigate) {
                    navigate('/customers');
                }
            } else {
                dispatch({
                    type: CUSTOMERS_FAIL,
                    payload: response.message || 'Failed to create customer',
                    validationErrors: response.data
                });
                toast.error(response.message || 'Failed to create customer');
            }
            
            return response;
        } catch (error) {
            let errorMessage = 'An error occurred while creating the customer';
            let validationErrors = null;
            
            if (error && error.data && Array.isArray(error.data)) {
                validationErrors = error.data;
                errorMessage = error.message || errorMessage;
            } else if (error && error.message) {
                errorMessage = error.message;
            }
            
            dispatch({
                type: CUSTOMERS_FAIL,
                payload: errorMessage,
                validationErrors
            });
            
            toast.error(errorMessage);
            throw error;
        }
    };
};

// Update customer
export const updateCustomerAction = (customerId, customerData, navigate) => {
    return async (dispatch) => {
        try {
            dispatch(setLoading());
            
            const response = await CustomerService.updateCustomer(customerId, customerData);
            
            if (response.success) {
                dispatch({
                    type: CUSTOMER_UPDATE_SUCCESS,
                    payload: response.data
                });
                
                toast.success(response.message || 'Customer updated successfully');
                
                if (navigate) {
                    navigate('/customers');
                }
            } else {
                dispatch({
                    type: CUSTOMERS_FAIL,
                    payload: response.message || 'Failed to update customer',
                    validationErrors: response.data
                });
                toast.error(response.message || 'Failed to update customer');
            }
            
            return response;
        } catch (error) {
            let errorMessage = 'An error occurred while updating the customer';
            let validationErrors = null;
            
            if (error && error.data && Array.isArray(error.data)) {
                validationErrors = error.data;
                errorMessage = error.message || errorMessage;
            } else if (error && error.message) {
                errorMessage = error.message;
            }
            
            dispatch({
                type: CUSTOMERS_FAIL,
                payload: errorMessage,
                validationErrors
            });
            
            toast.error(errorMessage);
            throw error;
        }
    };
};

// Delete/Deactivate customer
export const deleteCustomerAction = (customerId) => {
    return async (dispatch) => {
        try {
            dispatch(setLoading());
            
            const response = await CustomerService.deleteCustomer(customerId);
            
            if (response.success) {
                dispatch({
                    type: CUSTOMER_DELETE_SUCCESS,
                    payload: customerId
                });
                
                toast.success(response.message || 'Customer deactivated successfully');
            } else {
                dispatch({
                    type: CUSTOMERS_FAIL,
                    payload: response.message || 'Failed to delete customer'
                });
                toast.error(response.message || 'Failed to delete customer');
            }
            
            return response;
        } catch (error) {
            const errorMessage = error.message || 'An error occurred while deleting the customer';
            dispatch({
                type: CUSTOMERS_FAIL,
                payload: errorMessage
            });
            toast.error(errorMessage);
            throw error;
        }
    };
};
